import { gql, useQuery } from '@apollo/client';

export const IS_CUTOFF_VISIBLE = gql`
    query IsCutoffVisible($hubId: Long!) {
        isCutoffVisible(hubId: $hubId)
    }
`;

interface IsCutoffVisibleResponse {
    isCutoffVisible: boolean;
}

/**
 * 当前 hub 是否可见 Cutoff 菜单（后端按 hub+线路灰度自定义解析，格式与 checkWarehouseIdInGrayConfig 不同，故单独 hook）。
 */
export const useIsCutoffVisible = (hubId?: string | number, skip = false) => {
    const { data, loading } = useQuery<IsCutoffVisibleResponse>(IS_CUTOFF_VISIBLE, {
        variables: { hubId: hubId != null ? Number(hubId) : null },
        skip: skip || hubId == null,
        fetchPolicy: 'network-only',
    });
    return { visible: data?.isCutoffVisible ?? false, loading };
};
